import { loader } from 'graphql.macro'

export default async function deactivateUser ({ dataLoaders, variables }) {
  const schema = loader('./deactivateUser.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      userId: variables.userId
    }
  })
  return response.deactivateUser
}
